<template>
  <div class="home">
    <div class="all">
      <div class="about">
        <div class="title">
          <div>关于我们</div>
        </div>
        <div class="content">详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情</div>
      </div>
      <div class="person">
        <div v-for="item in perlist" :key="item.id" class="single" @click="godetail(item)">
          <img :src="item.picture" alt="">
          <div class="content">
            <div class="name">{{ item.name }}</div>
            <div class="intro">{{ item.selfIntroduction }}</div>
            <div class="location">{{ item.location }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import HomeApi from '../../api/home/index'
export default {
  name: '',
  components: {

  },
  // 定义属性
  data() {
    return {
      perlist: []
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    init() {
      HomeApi.gitsystem().then(res => {
        this.perlist = res.data.teamIntroduction
      })
    },
     godetail(data){
      let objData = JSON.stringify(data)
      this.$router.push({
        path:'aboutd',
        query:{detail: encodeURIComponent(objData)}

      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.home {
  background: #EDF4F8;
  box-sizing: border-box;
  padding-top: 25px;
  padding-bottom: 80px;
  overflow-y: auto;
}

.all {
  width: 73%;
  margin: 0 auto;
  background: #EDF4F8;
 

  .about {
    background: #fff;
     box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    .title {
      border-bottom: 1px solid #ddd;

      div {
        padding: 10px 25px;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
      }
    }

    .content {
      padding: 10px 25px;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
    }
  }

  .person {
    
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    //  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    .single {
      padding: 20px;
      margin-bottom: 15px;
      box-sizing: border-box;
      width: 49%;
      background: #FFFFFF;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      img {
        width: 170px;
        height: 220px;
        object-fit: cover;
      }

      .content {
        margin-left: 20px;
        flex: 1;
        display: flex;
        flex-flow: column;
        position: relative;

        .name {
          font-weight: 600;
          font-size: 20px;
          color: #333333;
        }

        .intro {
          margin-top: 12px;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }

        .location {
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }
}
</style>